import svg1 from "./../../images/COVID-Icons-1.svg";
import svg2 from "./../../images/COVID-Icons-2.svg";
import svg3 from "./../../images/COVID-Icons-3.svg";
import svg4 from "./../../images/COVID-Icons-4.svg";
import svg5 from "./../../images/COVID-Icons-5.svg";

const overviewData = {
  firstCard: {
    text: "Several vaccines have been developed safely and quickly to help protect you from COVID-19. They are proven to be effective in reducing your probability of contracting COVID-19. Once you are vaccinated, your body is much better prepared to shield off more viruses by making your immune system stronger.",
    image: svg1,
    alt: "vaccine",
  },
  secondCard: {
    text: "Wearing a mask reduces your chance of catching or spreading the coronavirus, it doesn’t eliminate it entirely. If you are infected with the coronavirus and do not know it, a mask is very good at keeping your respiratory droplets and particles from infecting others. It helps in limiting the spread of COVID-19.",

    image: svg2,
    alt: "mask",
  },
  thirdCard: {
    text: "If you have symptoms of COVID-19 ,stay home and self-isolate for 10 days from symptom onset, plus three days after symptoms cease. Call your health care provider or hotline for advice. Have someone bring you supplies. If you need to leave your house or have someone near you, wear a properly fitted mask to avoid infecting others.",

    image: svg3,
    alt: "stay home",
  },
  fourthCard: {
    text: "Physical distancing helps limit the spread of COVID-19. It means we keep a distance of at least 1.5m from each other and avoid spending time in crowded places or in groups. As we do not always know who may be sick with coronavirus. We can stay socially connected while physically distant – through video, call or text.",

    image: svg4,
    alt: "distance",
  },
  fifthCard: {
    text: "Wash your hands with soap and running water when hands are visibly dirty for 20-30 seconds. You can also clean them by using alcohol-based santizer. If you think a surface may be infected, clean it with simple disinfectant to kill the virus and protect yourself and others. Avoid touching your eyes, mouth, or nose.",
    alt: "Handwash",
    image: svg5,
  },
};

export default overviewData;
